module.exports = __webpack_public_path__ + "static/media/joshua-ness-109299-unsplash.2ff61012.jpg";